import axios from "axios";

const getAuthHeader = () => "Bearer " + localStorage.getItem("token");

const api = {
    post: async (endpoint, data) => {
        const url = process.env.REACT_APP_BACKEND_URL + endpoint;
        const config = { headers: { Authorization: getAuthHeader() } };
        const response = await axios.post(url, data, config);
        return response.data;
    }
};

export default api;